<template>
<div>

    <q-card>
        <div class="row ">
            <div class="col-6" style="background: #f2f7f4;">
                <img src="../../assets/otp.png" class="w-100" alt="otp">
            </div>
            <div class="col-6 p-2" style="background: #f2f7f4;">
                <div class="w-100">
                    <q-btn color="primary" class="float-right" dense flat icon="close" @click="closeDialog">
                        <q-tooltip>Close</q-tooltip>
                    </q-btn>
                </div>

                <template>
                    <div><h5>Redeem Points</h5></div>
                    <div class="py-2 mt-3 mb-3">
                        <h6 style="font-size: 16px;">Enter Minimum Redeem Points Set ({{schemeDetail.points}} points) or more to Redeem</h6>
                    </div>
                    <div>
                        <q-form ref="form">
                        <q-input class="mb-3" label="Enter Points" type="number" v-model="requestedPoints"
                                 :rules="[val=> val !== null && val !== '' || 'Please enter Points',
                                 val => val && val >= schemeDetail.points || 'should be greater than minimum redeem points set',
                                 val => val && val <= calculateClosingPoints(schemeEnrollmentObj, schemeDetail) || 'not available enough closing points']"></q-input>
             <!--(schemeEnrollmentObj.earnPoint+schemeEnrollmentObj.myTeamEarnPoint-schemeEnrollmentObj.redemPoint-schemeEnrollmentObj.redemptioInProgress)-->
                        <q-btn class="pd-btn my-3 q-pr-lg mr-2" @click="handleSubmit" size="12px">Redeem</q-btn>
                        <q-spinner color="green" size="2em" :thickness="2" v-if="loading"></q-spinner>
                        </q-form>
                    </div>
                </template>

            </div>
        </div>
    </q-card>

</div>
</template>

<script>
import {INSERT_REDEEM_POINTS} from '../../graphql/mutations/redeemPoints'
import moment from 'moment'
    export default {
        name: "RedeemPoint",
        props:['schemeDetail','schemeEnrollmentObj'],
        data:function(){
            return{
                user: JSON.parse(localStorage.getItem('user')),
                requestedPoints: 0,
                loading: false,
            }
        },
        methods:{
            closeDialog(){
               this.$emit('closeRedeemPointDialog', false)
            },
            handleSubmit(){
                var self = this
                this.$refs['form'].validate().then(success => {
                    if(success) {self.insertRedeemPoints()}
                })
            },
            async insertRedeemPoints(){
                this.loading = true
                let response = await this.$apollo.mutate({
                    mutation: INSERT_REDEEM_POINTS,
                    variables: {
                        id: this.generateUUID(),
                        createdBy: this.user.id,
                        partnerId: this.user.orgId,
                        schemeId: this.schemeDetail.id,
                        goalId: null,
                        points: this.requestedPoints,
                        status: 'Pending',
                        lastUpdatedBy: this.user.id,
                        approvedBy: null,
                        rejectedBy: null,
                        updatedOn: moment().format(),
                    },
                })
                if (response.data) {
                    this.loading = false
                    this.$emit('refetchSchemePoints', false)
                    this.closeDialog()
                    this.$q.notify('Points redeemed successfully')
                }
            },
            generateUUID () {
                return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
                    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8)
                    return v.toString(16)
                })
            },
        }
    }
</script>

<style scoped>

</style>
